import { useState } from "react"
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group"
import { invoiceSchema } from "./invoice.schema"
import PreviewEmail from "./preview-email"
import { useUser } from "@/api/users"
import { useCustomer } from "@/api/customers"
import PreviewPdf from "./preview-pdf"

interface InvoicePreviewProps {
  invoice: Zod.input<typeof invoiceSchema>;
}

type PreviewType = "email" | "pdf";

export default function InvoicePreview({ invoice }: InvoicePreviewProps) {
  const { user } = useUser()
  const { customer } = useCustomer(invoice.customerId)
  const [type, setType] = useState<PreviewType>("email")

  if (!user) return null

  return (
    <div className="md:w-6/12 lg:w-8/12 bg-blue-30 flex flex-col items-center p-3">
      <div className="w-full md:max-w-96 p-3 mb-2">
        <ToggleGroup
          className="shadow-sm"
          type="single"
          value={type}
          onValueChange={(value: PreviewType) => value && setType(value)}
        >
          <ToggleGroupItem value="pdf" className="w-full">
            Invoice PDF
          </ToggleGroupItem>
          <ToggleGroupItem value="email" className="w-full">
            Email
          </ToggleGroupItem>
        </ToggleGroup>
      </div>
      <div className="rounded-xl flex-grow bg-white shadow-md w-full md:max-w-xl mb-5 min-h-96 flex flex-col">
        {type === "email" && (
          <PreviewEmail invoice={invoice} customer={customer} user={user} />
        )}
        {type === "pdf" && <PreviewPdf invoice={invoice} />}
      </div>
    </div>
  )
}
